export const resumeData = {
    main: {
        name: "Victor Cuerdo",
        occupation: "Platform Support Engineer",
        description: "Platform Support Engineer with 5+ years in SaaS platform operations and cloud infrastructure. Engineered automated tooling that cut partner configuration time by 95% and reduced P1 incident resolution time by 30%.",
        image: "profilepic.jpg",
        bio: "Platform Support Engineer with 5+ years building automated workflows, resolving enterprise-scale incidents, and administering SaaS platforms across 4 global regions. Currently serving as Systems Support Analyst at Pebl (formerly Velocity Global), where I own the DevRev platform end-to-end for 200+ operations professionals across LATAM, EMEA, APAC, and Americas. Promoted within 8 months. Trilingual: English, Spanish, Russian.",
        contactmessage: "Open to Platform Support Engineer, Cloud Support Engineer, and Technical Support Engineer roles. Remote, US timezone overlap.",
        email: "victorcuerdop@gmail.com",
        phone: "+573011268985",
        address: {
            city: "Bogota",
            state: "Colombia",
            country: "Colombia"
        },
        website: "https://www.linkedin.com/in/vcuerdo",
        github: "https://github.com/VictorCuerdo",
        calendly: "https://calendly.com/victorcuerdop/30min",
        social: [
            {
                name: "linkedin",
                url: "https://www.linkedin.com/in/vcuerdo",
                className: "fa fa-linkedin"
            },
            {
                name: "github",
                url: "https://github.com/VictorCuerdo",
                className: "fa fa-github"
            }
        ]
    },
    resume: {
        education: [
            {
                school: "Universidad Del Norte",
                degree: "B.S. Computer Science",
                graduated: "2018 - 2023",
                location: "Barranquilla, Colombia"
            },
            {
                school: "Moscow Power Engineering Institute",
                degree: "Computer Science Studies",
                graduated: "2015 - 2017",
                location: "Moscow, Russia"
            }
        ],
        work: [
            {
                company: "Pebl (formerly Velocity Global)",
                title: "Systems Support Analyst",
                years: "Jan 2025 - Present",
                description: "Promoted from Platform Support Associate. Primary platform administrator for DevRev, supporting 200+ operations professionals across LATAM, EMEA, APAC, and Americas.",
                bullets: [
                    "Owned end-to-end DevRev platform configuration (SLAs, roles, permissions, workflows, templates, macros) for 200+ operations professionals across 4 global regions, ensuring 99%+ system availability",
                    "Engineered automated JSON configuration generator (Python, Node.js) for partner integrations, reducing setup time from 3 hours to under 10 minutes across 12 LATAM markets",
                    "Diagnosed data pipeline failures across AWS Lambda, Kinesis, and CloudWatch using Postman, cURL, and log analysis, restoring real-time ingestion within 4-hour SLA targets",
                    "Authored runbooks and RCA documentation via Confluence/Jira, reducing P1 resolution time by 30% through escalation protocols and postmortem-driven prevention"
                ],
                website: "https://hellopebl.com/"
            },
            {
                company: "Pebl (formerly Velocity Global)",
                title: "Platform Support Associate",
                years: "May 2024 - Dec 2024",
                description: "Provided tier-2 technical support for a global SaaS workforce platform serving 550+ employees.",
                bullets: [
                    "Resolved 200+ monthly tier-2 tickets for a 550+ employee global platform spanning payroll, access, and compliance across 4 regions with 95% SLA compliance",
                    "Re-engineered DevRev ticket intake and Slack-based routing workflows, reducing misrouted tickets by 40% and cutting mean first-response time by 55%",
                    "Earned promotion to Systems Support Analyst within 8 months after delivering automation improvements and leading P1/P2 incident triage"
                ],
                website: "https://hellopebl.com/"
            },
            {
                company: "Microsoft",
                title: "M365 Support Engineer & Copilot Ambassador",
                type: "Contract",
                years: "Apr 2024 - Sep 2024",
                description: "Contract engagement supporting enterprise adoption of Microsoft 365 Copilot for clients in Spain and Latin America.",
                bullets: [
                    "Led 8+ daily live Copilot demonstrations for enterprise clients in Spain via Microsoft Dynamics, driving AI adoption across M365 products",
                    "Troubleshot 50+ monthly M365 escalations across licensing, Entra ID/Azure AD, conditional access, and SSO (SAML, OAuth2) with 75% first-contact resolution",
                    "Designed Copilot integration and SSO deployment playbooks for 15+ enterprise accounts, reducing average deployment time by 40%"
                ],
                website: "https://www.microsoft.com/"
            },
            {
                company: "Interlatina",
                title: "Tech-Support Specialist",
                years: "Aug 2022 - Aug 2023",
                description: "Managed IT infrastructure and support operations for an international student exchange organization.",
                bullets: [
                    "Reduced IT incidents by 30% over 12 months through proactive monitoring, infrastructure upgrades, and standardized maintenance procedures",
                    "Implemented data backup and disaster recovery strategies, achieving zero data loss incidents and maintaining 100% data integrity across tenure"
                ],
                website: "https://interlatinacolombia.co/"
            },
            {
                company: "CR Consulting SAS",
                title: "Web Developer & IT Support Specialist",
                years: "Mar 2020 - Oct 2021",
                description: "Led web development projects and IT support operations for a consulting firm.",
                bullets: [
                    "Developed 5+ responsive web applications using JavaScript and React.js for business clients, achieving sub-3-second load times and secure authentication",
                    "Migrated legacy systems to modern JavaScript/React architecture and managed IT operations, reducing deployment cycles by 50% and maintaining consistent uptime"
                ],
                website: ""
            }
        ],
        skills: [
            {
                name: "Programming",
                keywords: ["Python", "JavaScript", "Node.js", "SQL", "Bash", "PowerShell", "HTML/CSS"]
            },
            {
                name: "Cloud & Infrastructure",
                keywords: ["AWS (Lambda, CloudWatch, Kinesis, IAM)", "Microsoft Azure (Entra ID, AD B2C)", "Google Cloud Platform", "Docker", "GitHub Actions", "CI/CD", "Linux"]
            },
            {
                name: "Databases & Frameworks",
                keywords: ["React.js", "REST APIs", "MySQL", "MongoDB", "Firebase", "SQLite"]
            },
            {
                name: "Platforms & Tools",
                keywords: ["DevRev", "Microsoft 365", "Microsoft Copilot", "GitHub Copilot", "Jira", "Confluence", "Zendesk", "Datadog", "Okta", "NetSuite", "DocuSign", "Postman", "cURL", "Git", "GitHub"]
            },
            {
                name: "Methodologies",
                keywords: ["Agile/Scrum", "SLA Management", "Incident Response", "On-Call", "RCA/Postmortems", "Workflow Automation", "SSO (SAML, OAuth2)", "ITIL"]
            }
        ],
        impactMetrics: [
            { value: 95, suffix: "%", label: "Config Time Reduction", description: "3 hours to 10 minutes" },
            { value: 30, suffix: "%", label: "P1 MTTR Reduction", description: "Via RCA & escalation protocols" },
            { value: 200, suffix: "+", label: "Ops Professionals", description: "Supported across 4 regions" },
            { value: 4, suffix: "", label: "Global Regions", description: "LATAM, EMEA, APAC, Americas" }
        ]
    }
};
